import type { AttachmentPreviewItem, AttachmentPreviewKind } from './AttachmentPreviewDialog'

const DOCUMENT_EXTENSIONS = new Set(['pdf', 'doc', 'docx', 'rtf', 'odt', 'pages'])
const SPREADSHEET_EXTENSIONS = new Set(['xls', 'xlsx', 'csv', 'tsv', 'ods', 'numbers'])
const PRESENTATION_EXTENSIONS = new Set(['ppt', 'pptx', 'odp', 'key'])
const DESIGN_EXTENSIONS = new Set(['fig', 'sketch', 'xd', 'psd', 'ai', 'indd'])
const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif', 'bmp', 'svg'])
const AUDIO_EXTENSIONS = new Set(['mp3', 'm4a', 'wav', 'ogg', 'oga', 'aac', 'flac'])
const VIDEO_EXTENSIONS = new Set(['mp4', 'webm', 'mov', 'm4v', 'ogv'])

const extensionOf = (name: string) => name.split('.').pop()?.trim().toLowerCase() ?? ''

export const inferAttachmentPreviewKind = (input: { name?: string; contentType?: string; mimeType?: string }): AttachmentPreviewKind => {
  const mime = (input.mimeType || input.contentType || '').toLowerCase()
  const ext = extensionOf(input.name ?? '')
  if (mime.startsWith('image/') || IMAGE_EXTENSIONS.has(ext)) return 'image'
  if (mime.startsWith('audio/') || AUDIO_EXTENSIONS.has(ext)) return 'audio'
  if (mime.startsWith('video/') || VIDEO_EXTENSIONS.has(ext)) return 'video'
  if (SPREADSHEET_EXTENSIONS.has(ext) || mime.includes('spreadsheet') || mime.includes('excel')) return 'spreadsheet'
  if (DOCUMENT_EXTENSIONS.has(ext) || PRESENTATION_EXTENSIONS.has(ext) || mime.includes('pdf') || mime.includes('word') || mime.includes('presentation')) return 'document'
  if (DESIGN_EXTENSIONS.has(ext)) return 'asset'
  return 'file'
}

export const canAnnotateAttachmentPreviewItem = (item: AttachmentPreviewItem) => {
  const mime = (item.mimeType ?? '').toLowerCase()
  const ext = extensionOf(item.label)
  return item.kind === 'image' || mime === 'application/pdf' || ext === 'pdf'
}
